<template>
  <div>
    <div
      class="background-image-login"
         :style="[settings.loginBackgroundImage && settings.loginBackgroundImage.absoluteUri ? {'backgroundImage': 'url(' + settings.loginBackgroundImage.absoluteUri + ')'} : {'backgroundImage': 'url(img/temp/cook.jpg)'}]"
    ></div>
    <!-- Header -->
    <div class="header py-8 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-3">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-1">
              <h1 class="text-white">Enable 2FA Verification</h1>
              <p class="text-lead text-white">
                Enable and confirm setup below.
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5" style="text-align:center;">
              <div class="login-error" v-if="errorMessage != null && Object.keys(errorMessage).length != 0">
                <p>{{ errorMessage }}</p>
              </div>

              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  role="form"
                  @submit.prevent="handleSubmit(onSubmit)"
                  class="login-form"
                >
           
                  <div class="justify-content-center">
                    <base-button  v-if="step === 'disabled'" @click="enable2FA"
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >Enable 2FA</base-button
                    >

                    <div v-if="step === 'enabled' && qrCode">
                      <img id="qrCode" :src="qrCode" alt="Scan this QR code" />
                    </div>

                    <base-input v-if="step === 'enabled' && qrCode"
                      label="Authenticator Code"
                      alternative
                      class="mb-3"
                      name="ValCode"
                      prepend-icon="ni ni-email-83"
                      placeholder="Enter authenticator code"
                      v-model="userCode"
                    >
                    </base-input>

                    <base-button @click="verify2FA" v-if="step === 'enabled' && qrCode"
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >Verify Code</base-button
                    >

                    <base-button v-if="step === 'enabled'" @click="disable2FA"
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >Disable 2FA</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import axios from 'axios';

export default {
  data() {
    return {
      qrCode: null,
      userCode: "",
      step: "",
      tempUserId: "",
      totpCode: "",
      submitted: false,
      submitting: false,
      errorMessage : ""
    };
  },
  computed: {
    user() {
      //return localStorage.getItem('user');
      return this.$store.state.authentication.user.user
    },    
    client() {
      return this.$store.state.clients.current;
    },
    settings() {
      return this.$store.state.settings.current;
    },
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
  },
  created() {
    this.$store.state.alert.message = '';

    this.step = this.user.totpSecret === '' || this.user.totpSecret === null || this.user.totpSecret === 'undefined' ? 'disabled' : 'enabled';

    var urlParams = new URLSearchParams(window.location.search);
    var client = urlParams.get('host');
    
    let $this = this.$store;
    $this.dispatch("clients/getCurrentClient", client)
    setTimeout(function() {
      $this.dispatch("settings/getSettings", $this.state.clients.current.id);
    }, 2500);
  },
  methods: {
    async enable2FA() {
      const response = await axios.post(`${process.env.VUE_APP_API_HOSTNAME}/api/users/enable-2fa`, { userid: this.user.id });
      this.qrCode = response.data.qrCode;
      this.step = 'enabled';
    },
    async disable2FA() {
      const response = await axios.post(`${process.env.VUE_APP_API_HOSTNAME}/api/users/disable-2fa`, { userid: this.user.id });
      //this.qrCode = response.data.qrCode;
      this.errorMessage = 'Your 2FA Authentication has been disabled.'
      this.step = 'disabled';
    },
    async verify2FA() {
      const response = await axios.post(`${process.env.VUE_APP_API_HOSTNAME}/api/users/verify-2fa`, { userid: this.user.id, code: this.userCode });
      if (response.data.token) {
        //localStorage.setItem("token", response.data.token);
        this.errorMessage = 'Your 2FA Authentication has been set up.'
      } else {
        alert("Invalid code.");
      }
    },
  },
};
</script>
<style>
  #qrCode { width: 400px; }
</style>